import { Icon } from '@iconify/react';
import RevealWrap from './RevealWrap';

const POS_LIST = [
  { name: '오케이포스', logo: '/landing/pos-okpos.png' },
  { name: 'NICE-오케이포스', logo: '/landing/pos-nice.png' },
  { name: 'KIS-오케이포스', logo: '/landing/pos-kis.png' },
  { name: '유니온포스', logo: '/landing/pos-union.png' },
];

export default function Integration() {
  return (
    <section id="integration" className="py-28 lg:py-40 bg-neutral-50 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none opacity-[0.03]" style={{
        backgroundImage: 'radial-gradient(circle, #000 1px, transparent 1px)',
        backgroundSize: '32px 32px',
      }} />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <RevealWrap animation="left">
            <p className="text-brand-600 font-semibold text-sm tracking-wide uppercase mb-3">POS Integration</p>
            <h2 className="text-3xl lg:text-4xl font-bold leading-tight tracking-tight text-neutral-900 mb-4">
              지금 쓰시는 POS,<br />단 하나도 건들 필요 없습니다
            </h2>
            <p className="text-neutral-500 text-lg leading-relaxed mb-8">
              국내 주요 POS사와 이미 연동이 완료되어 있습니다. 기존 포스를 교체하거나 설정을 바꿀 필요 없이, 그 위에 와우오더를 바로 얹으면 됩니다.
            </p>
            <div className="space-y-4 mb-8">
              {[
                '기존 POS 교체 불필요 — 그대로 사용',
                '설치 당일 연동 완료',
                '주문 데이터 자동 동기화',
                '사용 중인 POS가 목록에 없어도 상담해 주세요',
              ].map((t) => (
                <div key={t} className="flex items-start gap-3 group">
                  <div className="w-8 h-8 rounded-lg bg-brand-100 flex items-center justify-center flex-shrink-0 mt-0.5 group-hover:bg-brand-200 transition-colors duration-300">
                    <Icon icon="solar:check-circle-bold" className="text-brand-600 text-base" />
                  </div>
                  <span className="text-neutral-700 font-medium text-sm">{t}</span>
                </div>
              ))}
            </div>

            <a
              href="tel:1644-6827"
              className="inline-flex items-center gap-2 text-brand-600 font-semibold text-sm hover:underline"
            >
              <Icon icon="solar:phone-bold" className="text-base" />
              우리 매장 POS도 되는지 전화로 확인하기
            </a>
          </RevealWrap>

          <RevealWrap animation="right" className="reveal-delay-1">
            <div className="grid grid-cols-2 gap-4">
              {POS_LIST.map((p, i) => (
                <div
                  key={p.name}
                  className="group bg-white border border-neutral-200/80 rounded-2xl p-5 flex flex-col items-center justify-center gap-3 bento-item relative overflow-hidden"
                  style={{ transitionDelay: `${i * 80}ms` }}
                >
                  <div className="absolute inset-0 bg-gradient-to-br from-brand-400/0 to-brand-400/0 group-hover:from-brand-400/5 group-hover:to-transparent transition-all duration-500" />
                  <div className="h-16 flex items-center justify-center relative z-10">
                    <img
                      src={p.logo}
                      alt={p.name}
                      className="w-auto h-12 lg:h-14 object-contain"
                    />
                  </div>
                  <p className="text-neutral-600 text-xs font-medium relative z-10">{p.name}</p>
                </div>
              ))}
            </div>
            <p className="text-center text-neutral-400 text-sm mt-4">
              연동 POS는 계속 추가되고 있습니다
            </p>
          </RevealWrap>
        </div>
      </div>
    </section>
  );
}
